import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Car } from "lucide-react";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", password: "" });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k, v) => setF({ ...f, [k]: v });

  const submit = async (e) => {
    e.preventDefault();
    if (!acceptedTerms) { toast.error("Qeydiyyat üçün İstifadə şərtlərini qəbul etməlisiniz"); return; }
    setLoading(true);
    try { await register(f); toast.success("Qeydiyyat uğurludur. Emailinizi yoxlayın."); nav("/dashboard"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Xəta"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14 fade-in">
      <div className="flex justify-center mb-6"><div className="h-12 w-12 rounded-2xl bg-slate-900 flex items-center justify-center"><Car className="h-6 w-6 text-white" /></div></div>
      <h1 className="text-3xl font-extrabold tracking-tighter text-center text-slate-900">Qeydiyyat</h1>
      <p className="text-center text-slate-500 mt-1 mb-8">Auksion.az-a qoşulun</p>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 p-6 space-y-4">
        <GoogleSignInButton label="Google ilə qeydiyyat" />
        <div className="relative flex items-center py-1">
          <div className="flex-grow border-t border-slate-200"></div>
          <span className="mx-3 text-xs uppercase tracking-widest text-slate-400 font-bold">və ya</span>
          <div className="flex-grow border-t border-slate-200"></div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Ad</Label><Input data-testid="reg-first" value={f.first_name} onChange={e => upd("first_name", e.target.value)} required className="mt-1.5 rounded-xl h-12" /></div>
          <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Soyad</Label><Input data-testid="reg-last" value={f.last_name} onChange={e => upd("last_name", e.target.value)} required className="mt-1.5 rounded-xl h-12" /></div>
        </div>
        <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Email</Label><Input data-testid="reg-email" type="email" value={f.email} onChange={e => upd("email", e.target.value)} required className="mt-1.5 rounded-xl h-12" /></div>
        <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Telefon</Label><Input data-testid="reg-phone" value={f.phone} onChange={e => upd("phone", e.target.value)} placeholder="+994 XX XXX XX XX" required className="mt-1.5 rounded-xl h-12" /></div>
        <div><Label className="text-xs uppercase tracking-widest font-bold text-slate-500">Şifrə</Label><Input data-testid="reg-password" type="password" value={f.password} onChange={e => upd("password", e.target.value)} required minLength={6} className="mt-1.5 rounded-xl h-12" /></div>
        <label className="flex items-start gap-3 pt-2 cursor-pointer select-none">
          <Checkbox checked={acceptedTerms} onCheckedChange={setAcceptedTerms} data-testid="reg-terms-checkbox" id="reg-terms" className="mt-0.5" />
          <span className="text-sm text-slate-700 leading-snug">
            <Link to="/terms" target="_blank" rel="noopener" className="text-blue-600 font-semibold hover:underline">İstifadə şərtləri</Link> ilə tanış oldum və qəbul edirəm.
          </span>
        </label>
        <Button data-testid="reg-submit" type="submit" disabled={loading || !acceptedTerms} className="w-full rounded-full h-12 bg-blue-600 hover:bg-blue-700 font-semibold">{loading ? "Yaradılır..." : "Qeydiyyatdan keç"}</Button>
        <p className="text-center text-sm text-slate-600">Hesabınız var? <Link to="/login" className="text-blue-600 font-semibold">Giriş</Link></p>
      </form>
    </div>
  );
}
